import PropTypes from 'prop-types'
import React from 'react'
import { Modal } from 'react-bootstrap'

const propTypes = {
  /**
   * children prop
   */
  children: PropTypes.node,
}

function ModalBody(props) {
  const { children = null } = props ?? {}

  return <Modal.Body className="modal-body-sidebar unstyled-modal unstyled-tabs">{children}</Modal.Body>
}

ModalBody.propTypes = propTypes

export default ModalBody
